import {createBrowserRouter, Navigate} from 'react-router-dom';
import ErrorBoundaryLayout from '@/routes/ErrorBoundaryLayout';

import {
    NotFound,
    UserFormPage,
    OrderListPage,
    ReportPage,
} from '@/components/export';

const router = createBrowserRouter([
    {
        element: <ErrorBoundaryLayout />,
        children: [
            {path: '*', element: <NotFound />},
            {path: '/', element: <Navigate to={'/orders/byOrders'}/>},
            {path: '/login', element: <UserFormPage type={'login'} />},
            {path: '/orders/byOrders', element: <OrderListPage mode={'order'}/>},
            {path: '/orders/byProducts', element: <OrderListPage mode={'product'}/>},
            {path: '/report', element: <ReportPage />},
        ],
    },
]);

export default router;
